export default __webpack_public_path__ + "static/Hack-Italic-a596236fdc42eaec8b6116824b484612.woff2";